import React, { useState } from 'react';
import { Tag, X } from 'lucide-react';

const NewsletterTopics = ({ newsletterTopics, onTopicsChange }) => {
  const [inputValue, setInputValue] = useState('');

  const handleAddTopic = (topic) => {
    const trimmedTopic = topic.trim().toLowerCase();
    if (trimmedTopic && !newsletterTopics.topics.includes(trimmedTopic) && newsletterTopics.topics.length < 4) {
      onTopicsChange({
        topics: [...newsletterTopics.topics, trimmedTopic]
      });
      setInputValue('');
    }
  };

  const handleRemoveTopic = (topicToRemove) => {
    onTopicsChange({
      topics: newsletterTopics.topics.filter(topic => topic !== topicToRemove)
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddTopic(inputValue);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    // Remove commas as they're typed
    const cleanValue = value.replace(/,/g, '');
    setInputValue(cleanValue);
  };

  const handleBlur = () => {
    if (inputValue.trim()) {
      handleAddTopic(inputValue);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <Tag className="w-5 h-5 text-primary-600" />
        <h3 className="text-lg font-semibold text-gray-900">
          🗂️ What topics do you usually write about?
        </h3>
      </div>
      
      <p className="text-sm text-gray-600 mb-4">
        Help us create more relevant content by telling us your main themes. This guides metaphors, examples, and transitions.
      </p>

      <div className="space-y-4">
        {/* Topic Tags */}
        {newsletterTopics.topics.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {newsletterTopics.topics.map((topic, index) => (
              <div
                key={index}
                className="flex items-center gap-1 bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-medium"
              >
                <span>{topic}</span>
                <button
                  onClick={() => handleRemoveTopic(topic)}
                  className="ml-1 hover:bg-primary-200 rounded-full p-0.5"
                >
                  <X className="w-3 h-3" />
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Input Field */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Add topics (up to 4)
          </label>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            onBlur={handleBlur}
            placeholder="e.g., productivity, creativity, goal setting, personal systems"
            disabled={newsletterTopics.topics.length >= 4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-50 disabled:text-gray-500"
          />
          <p className="text-xs text-gray-500 mt-1">
            Press Enter or type a comma to add. {newsletterTopics.topics.length}/4 topics
          </p>
        </div>
      </div>

      <div className="mt-4 p-3 bg-green-50 rounded-md">
        <p className="text-xs text-green-700">
          💡 <strong>Pro tip:</strong> This helps us choose better metaphors and examples. If you write about "fatherhood," we might use parenting stories. If "productivity," we'll focus on systems and habits.
        </p>
      </div>
    </div>
  );
};

export default NewsletterTopics; 